import { combineReducers } from 'redux'

import authReducer from '@e3dc-react/shell/State/Auth/AuthReducer'
import appReducer from '@e3dc-react/shell/State/App/AppReducer'
import userReducer from './User/UserReducer'
import storageReducer from './Storage/StorageReducer'
import documentReducer from './Documents/DocumentReducer'
import apiViewReducer from '@e3dc-react/shell/State/ApiView/ApiViewReducer'
import navigationReducer from './Navigation/NavigationReducer'
import shopReducer from './Shop/ShopReducer'
import configurationReducer from './ShopSystemConfiguration/ShopSystemConfigurationReducer'
import qntmConfigurationReducer from './ShopQntmSystemConfiguration/ShopQntmSystemConfigurationReducer'

import { TypedUseSelectorHook, useSelector } from 'react-redux'
import modalReducer from '@e3dc-react/shell/State/Modals/ModalReducer'
import type { ModalState } from '../../src/Elements/ModalRoot'
import systemSettingReducer from './SystemSettings/SystemSettingReducer'
import eMobilityReducer from './E-Mobility/EMobilityReducer'

const rootReducer = combineReducers({
  auth: authReducer,
  app: appReducer,
  modal: modalReducer,
  user: userReducer,
  systemSettings: systemSettingReducer,
  storage: storageReducer,
  documents: documentReducer,
  apiView: apiViewReducer,
  navigation: navigationReducer,
  shop: shopReducer,
  systemStorage: configurationReducer,
  qntmStorage: qntmConfigurationReducer,
  eMobility: eMobilityReducer,
})

export type RootState = {
  //TODO: wenn Reducer selbst typisiert sind, `ReturnType<typeof ...>` mit passendem Type ersetzen
  auth: ReturnType<typeof authReducer>
  app: ReturnType<typeof appReducer>
  modal: ModalState
  user: ReturnType<typeof userReducer>
  systemSettings: ReturnType<typeof systemSettingReducer>
  storage: ReturnType<typeof storageReducer>
  documents: ReturnType<typeof documentReducer>
  apiView: ReturnType<typeof apiViewReducer>
  navigation: ReturnType<typeof navigationReducer>
  shop: ReturnType<typeof shopReducer>
  systemStorage: ReturnType<typeof configurationReducer>
  qntmStorage: ReturnType<typeof qntmConfigurationReducer>
  eMobility: ReturnType<typeof eMobilityReducer>
}

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector

export default rootReducer
